import { useId } from 'vue'

import type { JWT } from '@/types/Common'

const decodeBase64Url = (value: string): string => {
    const base64 = value.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=')
    const bytes = Uint8Array.from(atob(padded), char => char.charCodeAt(0))
    return new TextDecoder().decode(bytes)
}

export const parseJwt = (token: string): JWT | null => {
    if (!token) return null

    const splitToken = token.split('.')
    if (splitToken.length !== 3) return null

    const payloadData = token.split('.')[1] ?? ''

    return JSON.parse(decodeBase64Url(payloadData))
}

export const generateRandomId = (prefix = ''): string => {
    prefix = prefix ? `${prefix}-` : ''
    return `${prefix}${useId()}`
}

export const getNameInitials = (name: string) => {
    if (!name) return ''

    const splitName = name.split(' ')

    if (splitName.length > 0 && splitName[0] && splitName[1]) return (splitName[0].charAt(0) + splitName[1].charAt(0)).toUpperCase()
    return (name.charAt(0) + name.charAt(1)).toUpperCase()
}

export const NUMBER_ROUND = 1_000_000

export const numberRound = (val: number | string, numOfDecimals = 2) => {
    if (!numOfDecimals || numOfDecimals < 2) {
        numOfDecimals = 2
    } else if (numOfDecimals > 6) {
        numOfDecimals = 6
    }

    const numberToAdd = Math.trunc(5000 / Math.pow(10, numOfDecimals - 2))

    const num = Number(Number(val).toFixed(0))
    let numText = ''

    if (num >= 0) {
        numText = `${num + numberToAdd}`.padStart(7, '0')
    } else {
        numText = `${(num - numberToAdd) * -1}`.padStart(7, '0')
        numText = `-${numText}`
    }

    if (numText.slice(-(6 - numOfDecimals)) === '0'.repeat(6 - numOfDecimals)) {
        const lastDigit = numText.charAt(numText.length - (7 - numOfDecimals))
        switch (lastDigit) {
            case '1':
            case '3':
            case '5':
            case '7':
            case '9':
                numText = numText.slice(0, -(7 - numOfDecimals)) + String(Number(lastDigit) - 1) + numText.slice(-(6 - numOfDecimals))
        }
    }

    if (numOfDecimals < 6) {
        return `${numText.slice(0, -6)}.${numText.slice(-6, -6 + numOfDecimals)}`
    } else {
        return `${numText.slice(0, -6)}.${numText.slice(-6)}`
    }
}

export const hasCountryPrefix = (taxNumber: string) => {
    return /^[a-zA-Z]{2}/.test(taxNumber)
}

export const nullDate = '0001-01-01'
export const MongoDBNullId = '000000000000000000000000'
